import React, { useMemo, useRef, useState } from 'react';
import styles from '../Vendors.module.css';

/** Search a product by name, SKU or brand. products: inventory rows */
export default function ProductPicker({ products, value, onPick, placeholder = 'Search product...', autoFocus = false }) {
    const chosen = products.find((p) => String(p._id) === String(value));
    const [text, setText] = useState('');
    const [open, setOpen] = useState(false);
    const [hi, setHi] = useState(0);
    const box = useRef(null);
    const list = useMemo(() => {
        const q = text.trim().toLowerCase();
        return products.filter((p) => !q || [p.basicInfo?.productName, p.basicInfo?.sku, p.basicInfo?.brand].some((v) => String(v || '').toLowerCase().includes(q))).slice(0, 40);
    }, [products, text]);
    const pick = (p) => { onPick(p); setText(''); setOpen(false); };
    return (
        <div className={styles.picker} ref={box} onBlur={(e) => { if (!box.current?.contains(e.relatedTarget)) setOpen(false); }}>
            <input
                className={styles.input}
                value={open ? text : (chosen ? `${chosen.basicInfo?.productName}${chosen.basicInfo?.brand ? ` · ${chosen.basicInfo.brand}` : ''}` : text)}
                placeholder={placeholder}
                autoFocus={autoFocus}
                onFocus={() => { setOpen(true); setText(''); setHi(0); }}
                onChange={(e) => { setText(e.target.value); setOpen(true); setHi(0); }}
                onKeyDown={(e) => {
                    if (e.key === 'ArrowDown') { e.preventDefault(); setHi((h) => Math.min(h + 1, list.length - 1)); }
                    if (e.key === 'ArrowUp') { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
                    if (e.key === 'Enter' && open && list[hi]) { e.preventDefault(); pick(list[hi]); }
                    if (e.key === 'Escape') setOpen(false);
                }}
                aria-label="Product"
            />
            {open && (
                <ul className={styles.pickerList}>
                    {list.length === 0 && <li className={styles.muted} style={{ padding: 10 }}>No product matches. Add it in Inventory first.</li>}
                    {list.map((p, i) => (
                        <li key={p._id}>
                            <button type="button" className={i === hi ? styles.pickOn : ''} onMouseDown={(e) => e.preventDefault()} onClick={() => pick(p)}>
                                <span>{p.basicInfo?.productName}{p.basicInfo?.brand ? <small> · {p.basicInfo.brand}</small> : null}</span>
                                <small>Stock {p.stock?.currentQuantity || 0} · cost ₹{p.pricing?.purchasePrice || 0}</small>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
